
import { Ball, SimulationConfig, TrailCircle } from '@/types';

export const TrailLogic = {
  updateBall: (b: Ball, effectiveCfg: SimulationConfig, now: number, stepTS: number) => {
    const speed = Math.sqrt(b.vel.x * b.vel.x + b.vel.y * b.vel.y);
    const minSpeed = 5.0;
    const boost = 1.2;
    const progress = (now - (b.spawnTime || 0)) / 2000;
    if (speed < minSpeed || progress > 0.5) {
      const target = Math.max(speed, minSpeed * boost);
      const finalSpeed = Math.min(target, 5000);
      if (finalSpeed > speed && speed > 0.001) {
        b.vel.x = (b.vel.x / speed) * finalSpeed;
        b.vel.y = (b.vel.y / speed) * finalSpeed;
      }
    }
  },

  updateTrail: (
    b: Ball,
    effectiveCfg: SimulationConfig,
    deltaTime: number,
    substeps: number,
    currentTS: number,
    trailCircles: TrailCircle[],
    hue: number,
    pool: any,
    ballsCount: number = 1
  ) => {
    if (!effectiveCfg.trailEnabled && !effectiveCfg.enableTrails) {
        b.trail = [];
        if (trailCircles.length > 0) {
            trailCircles.forEach(c => pool.release(c));
            trailCircles.length = 0;
        }
        return;
    }
    if (!b.trail) b.trail = [];
    if (effectiveCfg.trailLength > 0) {
        b.trail.push({ ...b.pos });
        if (b.trail.length > effectiveCfg.trailLength) b.trail.shift();
    } else {
        b.trail = [];
    }

    if (effectiveCfg.trailDistanceBased) {
        if (!b.lastTrailPos) b.lastTrailPos = { ...b.pos };
        const dx = b.pos.x - b.lastTrailPos.x;
        const dy = b.pos.y - b.lastTrailPos.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        b.trailAccumulator = (b.trailAccumulator || 0) + dist;
        b.lastTrailPos = { ...b.pos };
    } else {
        b.trailAccumulator = (b.trailAccumulator || 0) + (deltaTime / substeps) * currentTS;
    }

    const interval = effectiveCfg.trailDistanceBased 
        ? Math.max(1, effectiveCfg.trailDistanceInterval)
        : Math.max(1, effectiveCfg.trailInterval);

    if (b.trailAccumulator >= interval) {
      const newCircle = pool.get({ ...b.pos }, b.radius, (hue + trailCircles.length * 2) % 360);
      
      if (effectiveCfg.trailOcclusionOptimization && effectiveCfg.trailPersistence) {
          let writeIdx = 0;
          for (let readIdx = 0; readIdx < trailCircles.length; readIdx++) {
              const old = trailCircles[readIdx];
              const dx = newCircle.pos.x - old.pos.x;
              const dy = newCircle.pos.y - old.pos.y;
              const distSq = dx * dx + dy * dy;
              let covered = false;
              if (newCircle.radius >= old.radius) {
                  const rDiff = newCircle.radius - old.radius;
                  if (distSq <= rDiff * rDiff) covered = true;
              }
              if (covered) pool.release(old);
              else trailCircles[writeIdx++] = old;
          }
          trailCircles.length = writeIdx;
      }

      trailCircles.push(newCircle);
      b.trailAccumulator = 0;
      
      const maxCircles = effectiveCfg.trailLength * Math.max(1, ballsCount);
      if (!effectiveCfg.trailPersistence && trailCircles.length > maxCircles) {
          const removed = trailCircles.shift();
          if (removed) pool.release(removed);
      }
    }
  }
};
